"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabControlLink = exports.TabControlButton = exports.TabList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const paper_1 = __importDefault(require("@kyruus/paper"));
const link_1 = __importDefault(require("@kyruus/link"));
exports.TabList = (0, styled_1.default)(paper_1.default) `
  box-sizing: border-box;
  display: flex;
  align-items: initial;
  justify-content: initial;
  flex-flow: row wrap;
  width: 100%;
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin: 0 auto;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  ${(props) => props.elevation === 0 ? 'margin-bottom: 0px;' : 'margin-bottom: 2px;'};

  &:focus-within {
    outline: ${(props) => props.as === 'nav'
    ? 'none'
    : `${(0, ui_theme_1.fromTheme)('border_width')(props)} solid ${(0, ui_theme_1.fromTheme)('color_link')(props)}`};
  }
  &:not(:focus-within) button[role='tab']:not([aria-selected='true']) {
    border: none;
  }
`;
exports.TabControlButton = (0, styled_1.default)('button') `
  margin: 1px 1px 1px 1px;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-decoration: none;
  border: none;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: ${({ useWithDropdown }) => useWithDropdown ? 'nowrap' : 'normal'};
  ${(_a) => {
    var { 'aria-selected': ariaSelected } = _a, rest = __rest(_a, ['aria-selected']);
    return ariaSelected
        ? `
      color: ${(0, ui_theme_1.fromTheme)('color_providermatch')(rest)};
      padding-bottom: 13px;
      border-bottom: 3px ${(0, ui_theme_1.fromTheme)('border_style')(rest)}
        ${(0, ui_theme_1.fromTheme)('color_providermatch')(rest)};
    `
        : `
      color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')(rest)};
    `;
}};
  &:focus {
    outline: 0;
    padding-bottom: 13px;
    border-bottom: 3px ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_providermatch')};
  }

  & > svg {
    margin-left: 4px;
  }

  &:hover {
    cursor: pointer;
  }
`;
exports.TabControlLink = (0, styled_1.default)(link_1.default) `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  white-space: ${({ useWithDropdown }) => useWithDropdown ? 'nowrap' : 'normal'};

  &,
  &:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }
  &:hover,
  &:hover:visited,
  &:focus,
  &:focus-within {
    text-decoration: none;
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
    padding-bottom: 13px;
    border-bottom: 3px ${(0, ui_theme_1.fromTheme)('border_style')} ${(0, ui_theme_1.fromTheme)('color_link')};
  }

  &:focus,
  &:focus-within {
    // negative offset to account for padding
    outline-offset: -${(0, ui_theme_1.fromTheme)('spacing_medium')};
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
  }

  text-decoration: none;
  border: none;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  display: flex;
  justify-content: center;
  align-items: center;
  ${(_a) => {
    var { selected } = _a, rest = __rest(_a, ["selected"]);
    return selected &&
        `
      color: ${(0, ui_theme_1.fromTheme)('color_link')(rest)};
      padding-bottom: 13px;
      border-bottom: 3px ${(0, ui_theme_1.fromTheme)('border_style')(rest)}
        ${(0, ui_theme_1.fromTheme)('color_link')(rest)};
    `;
}};
`;
//# sourceMappingURL=Tabs.styles.js.map